import { ArrowDownWideNarrowIcon, ArrowUpNarrowWideIcon } from "lucide-react";

import { SortableDefinitionsType } from "@/components/@types";

export const SORTABLES_STRING_OPERATORS = [
  {
    key: "ASC",
    name: "Ascending",
    symbol: "A-Z",
    ReactIcon: ArrowDownWideNarrowIcon,
    description: () => <>Sorts the column in ascending order</>,
  },
  // {
  //   key: "ASC_NULLS_FIRST",
  //   name: "Ascending (nulls first)",
  //   symbol: "?A-Z",
  //   ReactIcon: ArrowDownWideNarrowIcon,
  //   description: () => <>Sorts the column in descending order</>,
  // },
  // {
  //   key: "ASC_NULLS_LAST",
  //   name: "Ascending (nulls last)",
  //   symbol: "A-Z?",
  //   ReactIcon: ArrowDownWideNarrowIcon,
  //   description: () => <>Sorts the column in ascending order</>,
  // },
  {
    key: "DESC",
    name: "Descending",
    symbol: "Z-A",
    ReactIcon: ArrowUpNarrowWideIcon,
    description: () => <>Sorts the column in descending order</>,
  },
  // {
  //   key: "DESC_NULLS_FIRST",
  //   name: "Descending (nulls first)",
  //   symbol: "?Z-A",
  //   ReactIcon: ArrowUpNarrowWideIcon,
  //   description: () => <>Sorts the column in ascending order</>,
  // },
  // {
  //   key: "DESC_NULLS_LAST",
  //   name: "Descending (nulls last)",
  //   symbol: "Z-A?",
  //   ReactIcon: ArrowUpNarrowWideIcon,
  //   description: () => <>Sorts the column in descending order</>,
  // },
] as SortableDefinitionsType["operators"];

export const SORTABLES_NUMBER_OPERATORS = [
  {
    key: "ASC",
    name: "Ascending",
    symbol: "1-9",
    ReactIcon: ArrowDownWideNarrowIcon,
    description: () => <>Sorts the column in ascending order</>,
  },
  {
    key: "DESC",
    name: "Descending",
    symbol: "9-1",
    ReactIcon: ArrowUpNarrowWideIcon,
    description: () => <>Sorts the column in descending order</>,
  },
] as SortableDefinitionsType["operators"];

export const SORTABLES_BOOLEAN_OPERATORS = [
  {
    key: "ASC",
    name: "Ascending",
    symbol: "true",
    ReactIcon: ArrowDownWideNarrowIcon,
    description: () => <>Sorts the column in ascending order</>,
  },
  {
    key: "DESC",
    name: "Descending",
    symbol: "false",
    ReactIcon: ArrowUpNarrowWideIcon,
    description: () => <>Sorts the column in descending order</>,
  },
] as SortableDefinitionsType["operators"];

export const SORTABLES_ENUM_OPERATORS = [
  {
    key: "ASC",
    name: "Ascending",
    symbol: "A-Z",
    ReactIcon: ArrowDownWideNarrowIcon,
    description: () => <>Sorts the column in ascending order</>,
  },
  {
    key: "DESC",
    name: "Descending",
    symbol: "Z-A",
    ReactIcon: ArrowUpNarrowWideIcon,
    description: () => <>Sorts the column in descending order</>,
  },
] as SortableDefinitionsType["operators"];
